export const modalHeaderWrapper = {
    borderBottom: '1px solid $modalChannelInvitationBorder',
    paddingBottom: '15px',
}

export const modalContent = {minWidth: '500px'}

export const privilegesWrapper = {padding: '0 0 $modalChannelInvitationPaddingVertical'}

export const inviteesWrapper = {
    '& table > tbody': {
        'display': 'block',
        'maxHeight': '190px',
        'overflowY': 'auto',
        'td:nth-child(2)': {width: '100%'},
        'width': '100%',
    },
    'borderTop': '1px solid $modalChannelInvitationBorder',
    'padding': '$modalChannelInvitationPaddingVerticalLarge 0 $modalChannelInvitationPaddingVertical',
}

export const linkWrapper = {padding: '$modalChannelInvitationPaddingVertical 0'}

export const heading = {
    marginBottom: '$modalChannelInvitationPaddingVertical',
    marginTop: 0,
}

export const linkInputWrapper = {
    alignItems: 'center',
    button: {overflow: 'visible'},
    display: 'flex',
    gap: '10px',
    input: {
        marginTop: 0,
        width: '100%',
    },
}

export const copiedText = {fontSize: '$modalChannelInvitationTooltip'}
